import { Card, Stack, Typography } from '@mui/material';
import React from 'react';
import BarChart from '../../../Components/Charts/BarChart';
import { AppColors } from '../../../Utils/helper/AppColors';

export default function BarCard({ title }) {
	const chartData = {
		labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
		datasets: [
			{
				data: [2, 5, 2, 8, 3, 5, 10],
				backgroundColor: AppColors.CHART_BLUE,
			},
		],
	};
	return (
		<Card>
			<Stack gap={4} width="100%">
				<Typography variant="body1">{title}</Typography>
				<BarChart grid data={chartData} width="100%" />
			</Stack>
		</Card>
	);
}
